import axios from "axios";

export const HTTP_VERBS = {
    POST: "post",
    GET: "get",
    PUT: "put",
    DELETE: "delete",
};

export const CONTENT_TYPES = {
    APPLICATION_JSON: 'application/json',
    MULTIPART_FORM_DATA: 'multipart/form-data'
}

const headersConfig = (contentType) => {
    return {
        "Content-Type": contentType,
        accept: contentType,
    }
};


export const requestHttp = async ({
                                      method = HTTP_VERBS.POST,
                                      endpoint = '/',
                                      body = {},
                                      params = {}, //query params
                                      contentType = CONTENT_TYPES.APPLICATION_JSON,
                                  }) => {
    const base = 'api/';
    const url = `${base}${endpoint}`;
  //  const authToken = localStorage.getItem('token') ?? '';
    const options = {
        url,
        method,
        data: body,
        params,
        headers: headersConfig(contentType)
    };
    return axios(options);

};

export const httpFormDataReq = async ({
                                      method = HTTP_VERBS.POST,
                                      endpoint = '/',
                                      body = {},
                                      params = {}, //query params
                                      contentType = CONTENT_TYPES.MULTIPART_FORM_DATA,
                                  }) => {
    const base = 'api/';
    const url = `${base}${endpoint}`;
    //  const authToken = localStorage.getItem('token') ?? '';
    const options = {
        url,
        method,
        data: body,
        params,
        headers: headersConfig(contentType)
    };
    return axios(options);

};

